export default __webpack_public_path__ + "static/media/demo4.1d7c5d40.mp4";